import React from 'react';

const DownHeader = () => {
    return (
        <div className="hero mb-20  shadow-2xl min-h-screen" style={{ backgroundImage: `url("https://i.gifer.com/yV.gif")` }}>
            <div className="hero-overlay bg-opacity-60"></div>
            <div className="hero-content text-center text-neutral-content">
                <div className="max-w-md">
                    <h1 data-aos="zoom-in" className="mb-5 text-5xl font-bold"> "For me, the camera is a sketchbook, an instrument of intuition and spontaneity."</h1>
                </div>
            </div>
        </div>
    );
};

export default DownHeader;